import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  /**
   * Acá se declaran las variables a utilizar en el resto de las funciones del componente, importante énfasis en las siguientes:
   *
   * code: Código del mensaje de respuesta a mostrar en la función.
   * titulo: Título a enviar; solo si se recibe con la respuesta del endpoint.
   * detalle: Detalle a enviar; solo si se recibe con la respuesta del endpoint.
   */
    credentialsForm: FormGroup;
    visibleSpinner = false;
    successLogin = false;
    pass: string;
    regExpCorreo: string = environment.regExpCorreo;
    minLengthPass: number = environment.minLengthPass;

    // Variables para mensaje
    code: any;
    titulo: any;
    detalle: any;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private authService: AuthService) {
    }

    ngOnInit(): void {
        this.credentialsForm = this.formBuilder.group({
            correo: ['', [Validators.required, Validators.pattern(this.regExpCorreo)]],
            pass: ['', [Validators.required]]
        });

        document.getElementById('correo').focus();
        // Se verifica si existe algún mensaje pendiente de mostrar
        if (localStorage.getItem('msgbo')) {
          const type = localStorage.getItem('msgty');
          const title = localStorage.getItem('msgti');
          const body = localStorage.getItem('msgbo');

          setTimeout(() => {
            this.code = type;
            this.titulo = title;
            this.detalle = body;

            setTimeout(() => {
              localStorage.removeItem('msgty');
              localStorage.removeItem('msgti');
              localStorage.removeItem('msgbo');
           
            }, 1000);
          }, 500);
        }
       
    }

    iniciarSesion(): void {
        localStorage.clear();
        this.visibleSpinner = true;
        this.code = '';
        this.detalle = '';

        this.authService.iniciarSesion(this.credentialsForm.value.correo, this.credentialsForm.value.pass)
            .subscribe((res: any) => {
                this.visibleSpinner = false;

                if (res.success) {
                    if (res.data.code === 11) {
                        this.code = 'login.warn.11';
                        setTimeout(() => {
                            this.router.navigate(['auth/change-pass']);
                        }, 4500);
                    } else if (res.data.code === 12 || res.data.code === 13) {
                        this.code = 'login.warn.12';
                        this.detalle = res.data.message;
                        setTimeout(() => {
                            this.router.navigate(['auth/reset-pass']);
                        }, 4500);
                    } else {
                        this.successLogin = true;
                        // Se almacena el usuario y token en localStorage
                        localStorage.setItem('un', this.credentialsForm.value.correo);
                        localStorage.setItem('at', res.data.access_token);

                        // Se almacena el usuario y token en service
                        this.authService.setUsuario(this.credentialsForm.value.correo);
                        this.authService.setToken(res.data.access_token);

                        this.authService.obtenerInformacionUsuario()
                            .subscribe((resu: any) => {
                                this.visibleSpinner = false;

                                if (resu.success && resu.status_code === 200) {
                                    this.code = 'login.success.default';
                                    localStorage.setItem('nc', resu.data.usuario.nombre + ' ' + resu.data.usuario.apellido);
                                    this.authService.setLoggedIn(true);
                                    setTimeout(() => {
                                        this.router.navigate(['inicio']);
                                    }, 1000);
                                } else {
                                    this.code = 'login.warn.13';
                                }

                            }, error => {
                                this.code = 'login.warn.14';
                                this.detalle = error;
                            });
                    }
                } else {
                    let errores = '';
                    this.visibleSpinner = false;

                    if (res.data.message === 'Ver errores en extras') {
                        if (res.data.extra.length > 1) {
                            errores += '<ul>';
                            errores += '<li>' + res.data.extra.join('</li><li>') + '</li>';
                            errores += '</ul>';
                        } else {
                            errores = res.data.extra[0];
                        }
                    } else {
                        errores = res.data.message;
                    }
                    this.code = 'login.warn.15';
                    this.detalle = errores;
                }
            }, error => {
                this.visibleSpinner = false;
                this.code = 'login.error.default';
                this.detalle = error;
            });
    }
}
